import { render, staticRenderFns } from "./BaseServicerPanel.vue?vue&type=template&id=56310c5e"
import script from "./BaseServicerPanel.vue?vue&type=script&lang=js"
export * from "./BaseServicerPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports